import styled from "styled-components";

export const SectionBlock = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 28px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 18px 14px;
    border-radius: 12px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`;

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: var(--fixit);
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 13px;
  color: var(--gray);
  margin: 0;
  line-height: 1.4;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

/* --- GRID LADO A LADO PADRÃO CUSTOMERS/EDIT --- */
export const StatementGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  width: 100%;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const StatementCard = styled.div`
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 18px 16px;
    border-radius: 12px;
  }

  .statement-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding-bottom: 14px;
    border-bottom: 1px solid #f0f0f0;

    .statement-title {
      font-size: 16px;
      font-weight: 700;
      color: var(--dark-gray);
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .statement-rows {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .statement-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    font-size: 14px;
    color: var(--gray);

    .statement-label {
      font-weight: 500;
      color: var(--dark-gray);
      display: inline-flex;
      align-items: center;
      gap: 6px;
    }

    .statement-val {
      font-weight: 600;
      color: var(--black);
      text-align: right;
    }

    &.discount {
      color: #27ae60;
      .statement-label, .statement-val {
        color: #27ae60;
        font-weight: 700;
      }
    }
  }

  .statement-divider {
    height: 1px;
    background: #f0f0f0;
    margin: 2px 0;
  }

  .statement-total {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;

    .total-label {
      font-size: 15px;
      font-weight: 700;
      color: var(--black);
    }

    .total-val {
      font-size: 20px;
      font-weight: 800;
      color: var(--fixit);
    }
  }

  .statement-footer {
    margin-top: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-top: 14px;
    border-top: 1px solid #f0f0f0;
    font-size: 13px;
    color: var(--gray);

    .footer-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      span {
        color: #64748b;
        font-weight: 500;
      }

      strong {
        color: var(--dark-gray);
        font-weight: 600;

        &.footer-exp {
          color: #b45309;
          font-weight: 700;
        }
      }
    }
  }
`;

export const OnboardingGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const SingleOnboardingCard = styled.div`
  background: #fafbfc;
  border: 1px solid #eaedf1;
  border-radius: 12px;
  padding: 24px 28px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 18px 16px;
  }
`;

export const OnboardingTwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  width: 100%;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const OnboardingColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const OnboardingCard = styled.div`
  background: #fafbfc;
  border: 1px solid #eaedf1;
  border-radius: 10px;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const OnboardingCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #eaedf1;
  padding-bottom: 12px;
`;

export const OnboardingCardTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  color: var(--dark-gray);
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const OnboardingDetailsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
`;

export const OnboardingDetailItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  flex-wrap: wrap;
  padding-bottom: 12px;
  border-bottom: 1px solid #edf0f3;

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  .detail-label {
    color: var(--gray);
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .detail-value {
    color: var(--black);
    font-weight: 600;
    text-align: right;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
`;

export const TabBadge = styled.span<{ $variant?: "default" | "success" | "neutral" }>`
  font-size: 11.5px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  ${({ $variant }) => {
    switch ($variant) {
      case "success":
        return `
          background-color: rgba(39, 174, 96, 0.12);
          color: #27ae60;
          border: 1px solid rgba(39, 174, 96, 0.25);
        `;
      case "neutral":
        return `
          background-color: #f0f2f5;
          color: var(--gray);
          border: 1px solid #e1e4e8;
        `;
      default:
        return `
          background-color: rgba(152, 53, 209, 0.1);
          color: var(--fixit);
          border: 1px solid rgba(152, 53, 209, 0.25);
        `;
    }
  }}
`;

export const VoltageSelectorWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const VoltageOption = styled.button<{ $active: boolean; disabled?: boolean }>`
  padding: 5px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  border: 1px solid ${({ $active }) => ($active ? "var(--fixit)" : "#dcdcdc")};
  background: ${({ $active }) => ($active ? "rgba(152, 53, 209, 0.08)" : "var(--white)")};
  color: ${({ $active }) => ($active ? "var(--fixit)" : "var(--dark-gray)")};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    border-color: var(--fixit);
    color: var(--fixit);
  }
`;

export const ProposalDocumentButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background: var(--white);
  border: 1px solid rgba(152, 53, 209, 0.3);
  color: var(--fixit);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: rgba(152, 53, 209, 0.06);
    border-color: var(--fixit);
    text-decoration: none;
    color: var(--fixit);
  }
`;

export const KitJumpButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background-color: rgba(152, 53, 209, 0.1);
  color: var(--fixit);
  border: 1px solid rgba(152, 53, 209, 0.25);
  border-radius: 12px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(152, 53, 209, 0.18);
    border-color: var(--fixit);
  }

  svg {
    font-size: 11px;
  }
`;

/* --- KIT DE FERRAMENTAS E INSUMOS (BLOCO DEDICADO 100% HORIZONTAL) --- */
export const KitSectionCard = styled.div`
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 24px 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 18px 16px;
    border-radius: 12px;
  }

  .kit-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 14px;
    border-bottom: 1px solid #f0f0f0;

    @media (max-width: 600px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .kit-section-title-wrap {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .kit-section-title {
      font-size: 16px;
      font-weight: 700;
      color: var(--dark-gray);
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .kit-section-subtitle {
      font-size: 13px;
      color: var(--gray);
      margin: 0;
    }
  }
`;

export const KitGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  width: 100%;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export const KitCard = styled.div`
  background: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.02);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(152, 53, 209, 0.25);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.04);
  }

  .kit-left {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    min-width: 0;
  }

  .kit-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--dark-gray);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .quantity-badge {
    background-color: rgba(152, 53, 209, 0.1);
    color: var(--fixit);
    font-weight: 700;
    font-size: 11.5px;
    padding: 3px 8px;
    border-radius: 6px;
    flex-shrink: 0;
  }
`;

export const ShowMoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: var(--fixit);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  padding: 8px 0 0 0;
  transition: opacity 0.2s;
  align-self: flex-start;

  &:hover {
    text-decoration: underline;
    opacity: 0.85;
  }

  svg {
    font-size: 16px;
  }
`;

/* --- TABELA OFICIAL PADRÃO --- */
export const PlanTableWrapper = styled.div`
  width: 100%;

  /* Garante ajuste perfeito a 100% da caixa e proporção exata de 50%/50% */
  table {
    min-width: 100% !important;
    border-spacing: 0 10px !important;
  }

  > div {
    min-height: auto !important;
  }

  th {
    padding: 0 16px 6px 16px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--gray) !important;
  }

  td {
    padding: 14px 16px !important;
    font-size: 13.5px !important;
  }
`;

export const CategoryBadge = styled.span`
  background-color: #f0f2f5;
  color: var(--gray);
  border: 1px solid #e1e4e8;
  font-size: 11.5px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

/* --- DOCUMENTOS E ACEITE --- */
export const DocumentsSection = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-start;
  margin-top: 4px;
  flex-wrap: wrap;
`;

export const DocumentButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background-color: var(--white);
  color: var(--fixit);
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  border: 1px solid rgba(152, 53, 209, 0.25);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: rgba(152, 53, 209, 0.05);
    border-color: var(--fixit);
  }

  svg {
    font-size: 14px;
  }
`;

export const FooterCard = styled.section`
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 18px 14px;
    border-radius: 12px;
  }
`;

export const TermsCheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 13.5px;
  color: var(--dark-gray);
  cursor: pointer;
  max-width: 650px;
  line-height: 1.45;
  user-select: none;

  input[type="checkbox"] {
    margin-top: 3px;
    width: 18px;
    height: 18px;
    accent-color: var(--fixit);
    cursor: pointer;
    flex-shrink: 0;
  }

  a {
    color: var(--fixit);
    text-decoration: underline;
    font-weight: 600;

    &:hover {
      color: #7b29a8;
    }
  }
`;
